import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row items-center justify-between gap-4" }
const _hoisted_2 = { class: "text-sm text-slate-500 dark:text-slate-200 order-2 sm:order-1" }
const _hoisted_3 = { class: "font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_4 = { class: "font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_5 = { class: "font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_6 = { class: "flex items-center space-x-2 order-1 sm:order-2 w-full sm:w-auto justify-center sm:justify-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "hidden md:flex items-center space-x-1"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "px-2 text-secondary-text/50 dark:text-secondary-dark-text/50"
}
const _hoisted_11 = { class: "md:hidden px-3 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 bg-primary/10 dark:bg-primary-dark/10 rounded-lg" }
const _hoisted_12 = ["disabled"]

import { computed } from 'vue'
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationBar',
  props: {
    currentPage: {},
    totalPages: {},
    total: {},
    perPage: {}
  },
  emits: ["update:page", "page-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const goToPage = (page: number) => {
    if (page < 1 || page > props.totalPages) return
    emit('update:page', page)
    emit('page-change', page)
}

const visiblePages = computed(() => {
    const pages: (number | string)[] = []
    const totalP = props.totalPages
    const current = props.currentPage

    if (totalP <= 1) return totalP === 1 ? [1] : []

    if (totalP <= 7) {
        for (let i = 1; i <= totalP; i++) pages.push(i)
    } else {
        pages.push(1)
        if (current <= 3) {
            for (let i = 2; i <= 4; i++) pages.push(i)
            pages.push('...')
            pages.push(totalP)
        } else if (current >= totalP - 2) {
            pages.push('...')
            for (let i = totalP - 3; i <= totalP; i++) pages.push(i)
        } else {
            pages.push('...')
            for (let i = current - 1; i <= current + 1; i++) pages.push(i)
            pages.push('...')
            pages.push(totalP)
        }
    }

    return pages
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createTextVNode(" Showing ", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString((__props.currentPage - 1) * __props.perPage + 1), 1),
      _cache[3] || (_cache[3] = _createTextVNode(" to ", -1)),
      _createElementVNode("span", _hoisted_4, _toDisplayString(Math.min(__props.currentPage * __props.perPage, __props.total)), 1),
      _cache[4] || (_cache[4] = _createTextVNode(" of ", -1)),
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.total), 1),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hidden xs:inline" }, " results", -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(__props.currentPage - 1))),
        disabled: __props.currentPage === 1,
        class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-slate-700 dark:text-slate-300 hover:bg-primary/5 dark:hover:bg-primary-dark/5 hover:border-primary dark:hover:border-primary-dark", __props.currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'])
      }, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "hidden sm:inline" }, "Previous", -1)),
        _createVNode(_unref(ChevronLeft), { class: "h-5 w-5 sm:hidden" })
      ], 10, _hoisted_7),
      (__props.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
                (page !== '...')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (goToPage(page as number)),
                      class: _normalizeClass(["px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 min-w-[2.5rem]", page === __props.currentPage
                            ? 'bg-primary text-white dark:bg-primary-dark dark:text-white shadow-md'
                            : 'bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-slate-700 dark:text-slate-300 hover:bg-primary/5 dark:hover:bg-primary-dark/5 hover:border-primary dark:hover:border-primary-dark'])
                    }, _toDisplayString(page), 11, _hoisted_9))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "..."))
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, _toDisplayString(__props.currentPage) + " / " + _toDisplayString(__props.totalPages || 1), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(__props.currentPage + 1))),
        disabled: __props.currentPage === __props.totalPages,
        class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-slate-700 dark:text-slate-300 hover:bg-primary/5 dark:hover:bg-primary-dark/5 hover:border-primary dark:hover:border-primary-dark", __props.currentPage === __props.totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'])
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "hidden sm:inline" }, "Next", -1)),
        _createVNode(_unref(ChevronRight), { class: "h-5 w-5 sm:hidden" })
      ], 10, _hoisted_12)
    ])
  ]))
}
}

})